<template>
  <div class="d-flex full-width">
  <v-combobox v-model="selectedModules"
              :items="listOfModules"
              small-chips
              deletable-chips
              :dense="xs"
              :label="$t('searchScope')"
              clearable
              multiple
              multiLine
              hide-no-data
              hide-selected
              hide-details
              :color="theme.elements.btnColor"
              :item-color="theme.elements.btnColor"
              class="select-modules d-flex flex-grow-1 pl-3 py-2">
    <template v-slot:append>

    </template>
  </v-combobox>
  <module-filter-info></module-filter-info></div>
</template>

<script>
import ModuleFilterInfo from './ModuleFilterInfo.vue';
import commonMixin from '@/mixins/common';

export default {
  name: 'ModuleSelection',
  mixins: [commonMixin],
  components: {ModuleFilterInfo},

  props: {
    listOfModules: {
      type: Array,
    },
  },

  computed: {
    selectedModules: {
      // getter
      get() {
        return this.$store.state.search.selectedModules;
      },
      // setter
      set(value) {
        this.$store.commit('search/setSelectedModules', value);
      },
    },
  },
};
</script>
<style>
/* don't scoped - it's not working  */
.select-modules > div > div > div > .v-label {
  font-size: 0.9rem !important;
}

@media all and (max-width: 600px) {
  .select-modules > div > div > div > .v-label {
    font-size: 0.8rem !important;
  }
}
</style>
